'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.inject = void 0;
function inject(key) {
    return function (target, propertyKey, parameterIndex) {
        if (!target.hasOwnProperty('__injects')) {
            target.__injects = Array.from({ length: target.length });
        }
        if (!target.__injects) return;
        target.__injects[parameterIndex] = key;
    };
}
exports.inject = inject;
// export function injectable<T extends Ctr<any>>(constructor: T) {
//     return constructor;
// }
